// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__MjG28","customcheckbox":"Checkbox_customcheckbox__EOgaM"};